import { ApiResponse, TicketManagerTicketActionLog } from '@vision/ui/interfaces';
import { TicketManagerTicketActionLogAction } from '@vision/ui/enums';

export interface TicketManagerTicketActionLogActorResponseDto {
  email?: string;
  id: string;
  name?: string;
  nickname?: string | null;
  surname?: string;
  type: string;
}

export interface TicketManagerTicketActionLogChangeResponseDto {
  from_value: string | null;
  to_value: string | null;
}

export interface TicketManagerTicketActionLogResponseDto {
  action: TicketManagerTicketActionLogAction;
  action_change: TicketManagerTicketActionLogChangeResponseDto | null;
  actor: TicketManagerTicketActionLogActorResponseDto;
  created_at: string;
  id: number;
}

function mapActionLogActor(dto: TicketManagerTicketActionLogActorResponseDto): TicketManagerTicketActionLog['actor'] {
  return {
    email: dto.email,
    id: dto.id,
    name: dto.name,
    nickname: dto.nickname,
    surname: dto.surname,
    type: dto.type,
  };
}

function mapActionLogItem(dto: TicketManagerTicketActionLogResponseDto): TicketManagerTicketActionLog {
  const actionChange: TicketManagerTicketActionLog['actionChange'] = dto.action_change
    ? {
        fromValue: dto.action_change.from_value,
        toValue: dto.action_change.to_value,
      }
    : null;

  return {
    action: dto.action,
    actionChange,
    actor: mapActionLogActor(dto.actor),
    createdAt: dto.created_at,
    id: dto.id,
  };
}

export function normalizeTicketActionLogsResponse(
  response: ApiResponse<TicketManagerTicketActionLogResponseDto[]>,
): ApiResponse<TicketManagerTicketActionLog[]> {
  return {
    data: response.data.map(mapActionLogItem),
    meta: response.meta,
    object: response.object,
    url: response.url,
  };
}
